import ICoinData from './ICoinData';
import { BaseModel } from "../../vendor_core/core/src/model/BaseModel";
import ViewManager from '../../vendor_core/core/src/utils/ViewManager';
import { DefaultLayers } from '../../vendor_core/core/src/utils/Layers';
import SpinModel from '../../vendor_core/core/src/model/SpinModel';
import ReelGroup from '../../vendor_core/core/src/views/ReelGroup';
import BitmapTextField from '../../vendor_core/core/src/views/components/BitmapTextField';
import TextField from '../../vendor_core/core/src/views/components/TextField';
import BetModel from '../../vendor_core/core/src/model/BetModel';
import App from '../../vendor_core/core/src/App';
import BangUp from '../../vendor_core/core/src/utils/BangUp';
import ReelSymbol from '../../vendor_core/core/src/views/Symbol';
import Layout from '../../vendor_core/core/src/utils/Layout';
import SceneView from '../../vendor_core/core/src/views/SceneView';
import SpineAnimation from '../../vendor_core/core/src/views/SpineAnimation';
import { Commands } from '../../vendor_core/core/src/commands/CommandEnum';
import CommandManager from '../../vendor_core/core/src/commands/CommandManager';
import Utils from '../src/Utils';
import GameModel from '../../vendor_core/core/src/model/GameModel';
import SoundController from '../../vendor_core/core/src/utils/SoundController';
import ConsoleUtil from '../../vendor_core/core/src/utils/ConsoleUtil';
import { Tween } from '../../vendor_core/core/src/Tween';
class CoinModel extends BaseModel<ICoinData> {
    public endState: number = 0;
    public currentChestState: number = 0;
    public showedCoins: {x: number, y: number}[] = [];
    public forDestroy: (TextField | BitmapTextField)[] = [];
    private chestScene: SceneView = null;
    private reeBackScene: SceneView = null;
    private coinScene: SceneView = null;
    public activeCoins: number = 0;
    private coinRainAnimations: SpineAnimation[] = [];
    private hasAnticipation: boolean = false;
    public isCoinRainPlayed: boolean = false;

    private coinCollectionsIsBlank: boolean[] = [];

    get hasCoin(): boolean {
        const cascadeData = SpinModel.generations[SpinModel.cascadeIndex];
        return cascadeData?.currentCoins?.length !== cascadeData?.newCoins?.length
    }
    get hasCoinToCollect(): boolean {
        return this.activeCoins > 0
    }
    get hasCoinRain(): boolean {
        const cascadeData = SpinModel.generations[SpinModel.cascadeIndex];
        return cascadeData?.coinRainTriggered && !this.isCoinRainPlayed
    }
    get coinRainIndex(): number {

        let result = 1;

        if (this.currentChestState >= 3 && this.currentChestState < 6) {
            result = 2;
        } else if (this.currentChestState >= 6 && this.currentChestState < 9) {
            result = 3;
        } else if (this.currentChestState >= 9 && this.currentChestState < 12) {
            result = 4;
        } else if (this.currentChestState >= 12) {
            result = 5;
        };

        return result
    }

    public setCoinCollectionState(idx: number, isBlank: boolean): void {
        this.coinCollectionsIsBlank[idx] = isBlank;
    }

    changeState(state?: number): void {
        if (this.chestScene === null) {
            this.chestScene = ViewManager.getLayer("ChestBar")?.getCurrentScene();
        }
        if (this.reeBackScene === null) {
            this.reeBackScene = ViewManager.getLayer(DefaultLayers.ReelsBack)?.getCurrentScene();
        }

        if (!state) {
            state = this.endState;
        }

        const chestAnim = this.chestScene.spineAnimations.get("chest");
        const chestCoinAnim = this.reeBackScene.spineAnimations.get("chestCoins");

        if (this.currentChestState !== state) {
            if (state > 0 && state <= 16) {
                chestAnim.playChainingAnim(`transition_${state}`);
            }
            if (state > 1 && state <= 16) {
                chestCoinAnim.playChainingAnim(`transition_${state}`);
                SoundController.playSound("coinMountainGrows");
            }
            this.currentChestState = state;
        }

        // Remove frame anticipation anim if needed
        if (this.hasAnticipation) {
            // this.stopAnticipation();
        }

    }

    playCoinRainChestAnim(): void {
        const chestAnim = this.chestScene.spineAnimations.get("chest");
        chestAnim.playAsync(`st_${this.currentChestState}_coin_rain`).then(() => {
            chestAnim.play(`st_0_loop`);
        });
        this.currentChestState = 0;
    }
    playChestCollectAnim(): void {
        if (this.currentChestState !== this.endState) {
            this.changeState();
        } else {
            const chestAnim = this.chestScene.spineAnimations.get("chest");
            const chestCoinAnim = this.reeBackScene.spineAnimations.get("chestCoins");

            chestCoinAnim.playAsync(`c_st_${this.currentChestState}_coin`).then(() => {
                chestCoinAnim.play(`c_st_${this.currentChestState}_loop`, true);
            });

            chestAnim.playAsync(`st_${this.currentChestState}_coin${this.activeCoins > 1 ? this.activeCoins : ""}`).then(() => {
                chestAnim.playAsync(`st_${this.currentChestState}_loop`).then(() => {
                        if (!this.hasCoinRain) {
                            this.changeState();
                        }
                    });
            });
            // chestCoinAnim.play(`c_st_${this.currentChestState}_coin`);
            // chestAnim.playAsyncChainingStates(`collection_${this.currentChestState}`).then(() => {
            //     if (!this.hasCoinRain) {
            //         this.changeState();
            //     }
            // });
        }
    }

    /**
     * Update 5 collected coins
     */
    public updateCoinsState = (addCoins: number = 0, animDelay: number = 0) => {
        this.activeCoins += addCoins;
        if (this.activeCoins === 4 && !this.hasAnticipation && !this.hasCoinRain) {
            this.hasAnticipation = true;
            Utils.frameAnticipation(true);
        } else {
            if (this.hasAnticipation && this.activeCoins >= 5) {
                // SoundController.playSound("symbolRemoval5thCoin", false, null, false); // TODO2: delete this if there is no alternative sound 
            }
        }

        if (this.coinScene === null) {
            this.coinScene = ViewManager.getLayer("CoinBar")?.getCurrentScene();
        }

        if (this.activeCoins >= 5) {
            this.coinScene.spineAnimations.forEach(s => s.play("win"))
        } else {
            this.coinScene.spineAnimations.forEach((s, key) => {
                const idx: number = Number(key.split("_")[1]);
                if (idx <= this.activeCoins && this.coinCollectionsIsBlank[idx]) {
                    Tween.delayedCall(animDelay, () => {
                        s.playAsync("start", GameModel.turboSpin ? 1.5 : 1).then(() => s.play());
                        this.setCoinCollectionState(idx, false);
                    });
                }
            })
        }

    }

    stopAnticipation(): void {
        if (!this.hasAnticipation) return;
        this.hasAnticipation = false;
        Utils.frameAnticipation(false);
    }

    convertWinValue(value: number): string {
        // This convert to "3.44" format
        const converted = ((value / App.config.subUnits).toFixed(
            BetModel.currency.decimals
        ))
        // This convert to "k = 1000" format
        return Utils.formatWinAsSIForCoins((+converted), BetModel.currency.decimals)
    }
    /**
     * @returns Number of appeared coins
     */
    showNewCoins(): number {
        const cascadeData = SpinModel.generations[SpinModel.cascadeIndex];
        let coinNumber = 0;
        ReelGroup.instance.reels.forEach((r, ri) => {
            r.symbols.forEach((c, ci) => {
                    const symData = cascadeData?.newCoins?.find(s => s.coordinate.x === ri && s.coordinate.y === ci);
                    if (symData) {
                        c.setId(10);
                        this.playCoinTransformAnim(c, symData, "coin_appear", 1.3);
                        coinNumber += 1;
                    }
            })
        });


        this.updateCoinsState(coinNumber);
        return coinNumber
    }
    playCoinTransformAnim(sym :ReelSymbol, symData: any, anim?: string, timeScale: number = 1): void {
        if (anim) {
            sym.playAnimation(anim, timeScale).then(() => {
                if (symData.multiplier) {
                    this.showSymbolText(`x${symData.multiplier}`, symData.coordinate.x, symData.coordinate.y, 4);
                } else {
                    this.showSymbolText(`${this.convertWinValue(symData.value)}`, symData.coordinate.x, symData.coordinate.y, 3);
                }
                ReelGroup.instance.sortSymbols();
            })
        } else {
            if (symData.multiplier) {
                this.showSymbolText(`x${symData.multiplier}`, symData.coordinate.x, symData.coordinate.y, 4);
            } else {
                this.showSymbolText(`${this.convertWinValue(symData.value)}`, symData.coordinate.x, symData.coordinate.y, 3);
            }
        }

    }
    /**
     * @returns Number of coins to show
     */
    showCurrentCoins(): number {
        const cascadeData = SpinModel.generations[SpinModel.cascadeIndex];
        let coinNumber = 0;
        ReelGroup.instance.reels.forEach((r, ri) => {
            r.symbols.forEach((c, ci) => {
                if (c.id === 10) {
                    const symData = cascadeData?.currentCoins?.find(s => s.coordinate.x === ri && s.coordinate.y === ci)
                    if (symData && !c.textOverlay) {
                        this.playCoinTransformAnim(c, symData);
                        coinNumber += 1;
                    }
                }
            })
        });

        this.updateCoinsState(coinNumber, GameModel.turboSpin ? 0.4 : 0.8);
        return coinNumber
    }
    showSymbolText(text: string, reel: number, row: number, id: number): TextField | BitmapTextField {
        const reelGroup = (ViewManager.getLayer(DefaultLayers.Reels).setScene().getSubView("ReelGroup") as ReelGroup);
        const reelSymbol = reelGroup.getSymbolAt(reel, row);
        const reelSymbolTextField = reelSymbol.showTextOverlay(id, text);
        reelSymbol.setId(10);
        reelSymbol.playAnimation("idle")
        reelSymbol.setVisible(true)

        return reelSymbolTextField
    }

    updateTmWin(win: number, multiplier: number, benGupDuration: number): BangUp {
        const tumbleScene = ViewManager.getLayer("ThumbleWinCounter").setScene('open');
        const twPlate = tumbleScene.groups.get("tw_plate");
        const winTF = tumbleScene.sceneMoneyFields.get("tw_counter");
        const totalWin = tumbleScene.sceneMoneyFields.get("tw_total");
        const multiplierTF = tumbleScene.sceneTextFields.get("multi");
        twPlate.visible = true;
        const winBangUp = new BangUp();

        if (multiplier > 0) {
            const currentMultiplier = multiplierTF.text.split("x")[1];
            if (currentMultiplier) {
                multiplierTF.text = `x${multiplier + Number(currentMultiplier)}`;
            } else {
                multiplierTF.text = `x${multiplier}`;
            }
            // this.updatePersistentMultiplier(multiplier, benGupDuration);
        } else if (win > 0) {
            let startValue = SpinModel.cascades[SpinModel.cascadeIndex].tempWinAmount;

            winBangUp.startBangup(
                startValue,
                startValue + win,
                benGupDuration,
                {},
                (val) => totalWin.value = val
            );
            SpinModel.cascades[SpinModel.cascadeIndex].tempWinAmount += win;
            SpinModel.tempWinAmount += win;
            CommandManager.execute(Commands.UPDATE_TEMP_WIN);
        } else {
            // Here merge total value and total multiplier
            totalWin.alpha = 1;

            winBangUp.startBangup(
                SpinModel.cascades[SpinModel.cascadeIndex].tempWinAmount,
                SpinModel.winAmount,
                benGupDuration,
                {},
                (val) => totalWin.value = val
            );

            SpinModel.tempWinAmount = SpinModel.accumulatedWin;
            CommandManager.execute(Commands.UPDATE_TEMP_WIN);
        }

        // winBangUp.clearBangup();

        return winBangUp
    }
    returnElementToPool(anim: SpineAnimation): void {
        this.coinRainAnimations.push(anim);
    }
    /**
     *
     * @param sym
     * @returns Symbol Text overlay
     */
    getSymbolTextOverlay = (sym: ReelSymbol): TextField | BitmapTextField => {
        let text = sym.textOverlay.clone();
        if (text["textShape"]) {
            text["textShape"].alpha = 0;
        }
        ConsoleUtil.log(text);
        // debugger
        return text
    }
    /**
     * Clear/reset all props needed to start new spin
     */
    public clear = () => {
        // Clean coin bar
        this.coinScene?.spineAnimations?.forEach((s, key) => {
            const idx: number = Number(key.split("_")[1]);
            if (idx <= this.activeCoins) {
                s.playAsync("end", GameModel.turboSpin ? 2 : 1).then(() => {
                    s.play("blank");
                    this.setCoinCollectionState(idx, true);
                });
            }
        });
        this.activeCoins = 0;
        this.stopAnticipation();
    }
    /**
     * Clear/reset all props needed to start new spin
     */
    public clearTextOverlays = () => {
        // Clean text Overlays
        ReelGroup.instance.reels.forEach(r => r.symbols.forEach(s => {
            s.cleanTextOverlay();
            s.scale.set(1, 1);
        }))
    }
}

export default new CoinModel()
